import { Link } from "react-router-dom";
import useAuthUser from "../hooks/useAuthUser";

const Header = ({ children, title, back = "", addButton }) => {
  const { isAdminHrRole, isEmployeeRole, isManagerRole } = useAuthUser();

  const roleMap = {
    adminHr: isAdminHrRole,
    employee: isEmployeeRole,
    manager: isManagerRole,
  };

  const canShowAddButton =
    addButton &&
    Array.isArray(addButton.allowedRoles) &&
    addButton.allowedRoles.some((role) => roleMap[role]);

  const backHtml = back ? (
    <span className="add float-end">
      <Link to={back} className="btn btn-secondary btn-sm">
        <span className="icon">
          <img src="/public/images/back-arrow.svg" alt="back" />
        </span>
        <span className="text">Back</span>
      </Link>
    </span>
  ) : null;

  return (
    <>
      <h1 className="dashboard">
        <a href="/">
          <img src="/public/images/icon-home.svg" alt="Home" />
        </a>
        {title}
        {canShowAddButton && addButton.link && (
          <span className="add float-end">
            <Link to={addButton.link} className="btn btn-success btn-sm">
              {addButton.icon}&nbsp;
              <span className="text">{addButton.text}</span>
            </Link>
          </span>
        )}

        {children}
        {backHtml}
      </h1>
    </>
  );
};

export default Header;
